"use strict";

const FadeBaseAnimation = require('../FadeBaseAnimation');

/**
 * The first half of the alternating pulses animation
 *
 * Pulse one channel
 * Pulse the other channel
 * Repeat
 */
class AlternatePulsingTwo extends FadeBaseAnimation {

  constructor() {
    super();

    this.frameLength = 3; // Length in "ticks"
    const fadeLength = 30; // Length in ticks. ~ 300ms
    this.fadeIncrement = 250 / fadeLength; // +1 ensures brightness gets to 100%. This will happen for multiple frames, but that's alright

    const ch2FadeUpStart = 60;
    const ch2FadeDownStart = ch2FadeUpStart + fadeLength;

    this.totalFrames = ch2FadeDownStart + fadeLength;

    const channelOneOn = [];
    const channelTwoOn = [];
    for (let ch2FrameFadeUp = ch2FadeUpStart, ch2FadeUpMultiplier = 0 ; ch2FrameFadeUp < ch2FadeUpStart + fadeLength ; ch2FrameFadeUp++, ch2FadeUpMultiplier++) {
      channelOneOn.push({
        frame: ch2FrameFadeUp,
        brightness: Math.ceil(this.fadeIncrement * ch2FadeUpMultiplier)
      });
      channelTwoOn.push({
        frame: ch2FrameFadeUp,
        brightness: Math.ceil(this.fadeIncrement * ch2FadeUpMultiplier)
      });
    }

    for (let ch2FrameFadeDown = ch2FadeDownStart, ch2FrameFadeDownMultiplier = 29 ; ch2FrameFadeDown < ch2FadeDownStart + fadeLength ; ch2FrameFadeDown++, ch2FrameFadeDownMultiplier--) {
      channelOneOn.push({
        frame: ch2FrameFadeDown,
        brightness: Math.ceil(this.fadeIncrement * ch2FrameFadeDownMultiplier)
      });
      channelTwoOn.push({
        frame: ch2FrameFadeDown,
        brightness: Math.ceil(this.fadeIncrement * ch2FrameFadeDownMultiplier)
      });
    }

    this.channels = {
      1: channelOneOn,
      2: channelTwoOn
    };
  }

  /**
   * Get the display name for this animation
   * Used on buttons and reporting
   *
   * @returns {string}
   */
  static getDisplayName() {
    return '2nd';
  }
}

module.exports = AlternatePulsingTwo;
